import { RelodeApiError } from "@relode/core";

import { JobManagerContact, DashboardType } from "../../../shared/types";
import { MemberUpcomingInterview } from "./types/memberUpcomingInterview";
import { DashboardJobStatistics } from "./types";

export type ManagerStatTypes =
    | "submitted"
    | "interviewingPast"
    | "interviewingAwaitingFeedback"
    | "interviewingUpcoming"
    | "offered"
    | "hiredConfirmed"
    | "hiredUnconfirmed";

export type ManagerStatsType = Record<
    ManagerStatTypes,
    number | undefined | null
>;

export type MemberStatTypes =
    | "submitted"
    | "interviewingPast"
    | "interviewingPastAwaitingFeedback";

export type MemberStatsType = Record<
    MemberStatTypes,
    number | undefined | null
>;

export interface DashboardState {
    ui: {
        error?: RelodeApiError;
        isDashboardLoading: boolean;
        loadingType: boolean;
        loadingJobManager: boolean;
        managerIsBusy: {
            jobCounts: boolean;
            submitted: boolean;
            interviewingPast: boolean;
            interviewingAwaitingFeedback: boolean;
            interviewingUpcoming: boolean;
            offered: boolean;
            hiredConfirmed: boolean;
            hiredUnconfirmed: boolean;
            stats: boolean;
        };

        memberIsBusy: {
            jobCounts: boolean;
            submitted: boolean;
            interviewingPast: boolean;
            interviewingPastAwaitingFeedback: boolean;
            interviewingUpcoming: boolean;
        };
    };
    data: {
        jobManagerDetails?: JobManagerContact;
        showAllJobs: boolean;
        dashboardType: DashboardType;
        lastSync: Date;
        managerStats: ManagerStatsType;
        jobStatistics: DashboardJobStatistics;
        managerJobCounts: {
            open: number | undefined | null;
            closed: number | undefined | null;
            paused: number | undefined | null;
            pending: number | undefined | null;
            requested: number | undefined | null;
        };
        memberJobCounts: {
            open: number | undefined | null;
            closed: number | undefined | null;
            paused: number | undefined | null;
        };
        memberStats: MemberStatsType;
        upcomingMemberInterviews: MemberUpcomingInterview[];
    };
}

export const blankManagerStats: ManagerStatsType = {
    hiredConfirmed: undefined,
    hiredUnconfirmed: undefined,
    interviewingAwaitingFeedback: undefined,
    interviewingPast: undefined,
    interviewingUpcoming: undefined,
    offered: undefined,
    submitted: undefined,
};

export const blankMemberStats: MemberStatsType = {
    submitted: undefined,
    interviewingPast: undefined,
    interviewingPastAwaitingFeedback: undefined,
};

export const blankJobStatistics: DashboardJobStatistics = {
    avgFirstHireTimeInDays: undefined,
    avgFirstSubmitTimeInDays: undefined,
    avgTimeInSubmittedInDays: undefined,
    closedAndFilledCount: undefined,
    closedAndNotFilledCount: undefined,
    hiredToRejectedPercentage: undefined,
    interviewingToHiredPercentage: undefined,
    notClosedWithEmptyPipelineCount: undefined,
    notClosedWithFilledPipelineCount: undefined,
    submittedToInterviewingPercentage: undefined,
};

export const blankManagerJobCounts = {
    open: undefined,
    closed: undefined,
    paused: undefined,
    pending: undefined,
    requested: undefined,
};

export const blankMemberJobCounts = {
    open: undefined,
    closed: undefined,
    paused: undefined,
};

export const initialDashboardState: DashboardState = {
    ui: {
        error: undefined,
        isDashboardLoading: false,
        loadingJobManager: false,
        loadingType: false,
        managerIsBusy: {
            jobCounts: false,
            submitted: false,
            interviewingPast: false,
            interviewingAwaitingFeedback: false,
            interviewingUpcoming: false,
            offered: false,
            hiredConfirmed: false,
            hiredUnconfirmed: false,
            stats: false,
        },
        memberIsBusy: {
            jobCounts: false,
            submitted: false,
            interviewingPast: false,
            interviewingPastAwaitingFeedback: false,
            interviewingUpcoming: false,
        },
    },
    data: {
        showAllJobs: false,
        lastSync: new Date(),
        jobManagerDetails: undefined,
        dashboardType: DashboardType.None,
        managerStats: blankManagerStats,
        memberStats: blankMemberStats,
        upcomingMemberInterviews: [],
        managerJobCounts: blankManagerJobCounts,
        memberJobCounts: blankMemberJobCounts,
        jobStatistics: blankJobStatistics,
    },
};
